// extracted by mini-css-extract-plugin
export default {"question-group-scroll-container":"ImagesList_question-group-scroll-container__PUYud","question-group-container":"ImagesList_question-group-container__vDxAu"};